var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"mint-checkbox"},[_c('input',{staticClass:"mint-checkbox-input",attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.currentValue},on:{"change":_vm.change}}),_c('span',{staticClass:"mint-checkbox-core"})])
}
var staticRenderFns = []

export { render, staticRenderFns }